import { render, staticRenderFns } from "./TradeInDialog.vue?vue&type=template&id=e8b5ffb0&scoped=true"
import script from "./TradeInDialog.vue?vue&type=script&lang=js"
export * from "./TradeInDialog.vue?vue&type=script&lang=js"
import style0 from "./TradeInDialog.vue?vue&type=style&index=0&id=e8b5ffb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b5ffb0",
  null
  
)

export default component.exports